import { capitalizeFirstLetter } from 'UI/utils';

export const processBooleanOption = (value, label) => {
  if (value === true) return label;
  if (value === false) return `Not ${label}`;
  return null;
};

export const buildTravelString = travel => {
  if (!travel) return null;

  const parts = [];

  parts.push(processBooleanOption(travel.required, 'Required'));
  travel.percentage && parts.push(`${travel.percentage}%`);
  travel.frequency && parts.push(capitalizeFirstLetter(travel.frequency));
  travel.type && parts.push(travel.type);
  travel.mode && parts.push(travel.mode);

  return parts.filter(part => !!part).join(' / ');
};

export const buildMilitaryExperienceString = militaryExperience => {
  if (!militaryExperience) return null;

  const { rank, branch, location } = militaryExperience;

  const parts = [
    rank && capitalizeFirstLetter(rank.trim?.()),
    branch?.trim?.(),
    location?.trim?.()
  ].filter(Boolean);

  return parts.length ? parts.join(' / ') : null;
};

export const formatMonthYear = ({ year, month }) => {
  if (year && month) return `${month}/${year}`;

  if (year) return `${year}`;

  return null;
};

export const formatPeriod = ({ year, month }) => {
  if (year && month) {
    return `${month}/${year}`;
  }
  if (year) {
    return year;
  }
  if (month) {
    return month;
  }
  return '';
};
